import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core'
import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { PHBHPLayoutPackageService } from './ph-bhp-layout-package.service';
import { LoggingService } from 'src/app/services/logging.service';
import { of } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {

    constructor(
        private router: Router,
        public http: HttpClient,
        public translate: TranslateService,
        private layoutService: PHBHPLayoutPackageService,
        private logging: LoggingService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).catch(err => {
            this.logging.logError(err.message, err)
            var endUrl = req.url.replace(this.layoutService.apiUrl, "");
            if (endUrl == 'Accounts/RefreshToken' || err.status === 403) {
                this.clearTaken();
            } else if (err.status === 401) {
                const params = {
                    refreshToken: localStorage.getItem('refresh_token')
                };
                var headers: any = {}
                headers['Content-Type'] = 'application/json';
                return this.http.post(this.layoutService.apiUrl + 'Accounts/RefreshToken', params, { headers: new HttpHeaders(headers) }).flatMap((data: any) => {
                    if (data.access_token != null) {
                        localStorage.setItem('access_token', data.access_token);
                        localStorage.setItem('refresh_token', data.refresh_token);
                        req = req.clone({
                            setHeaders: {
                                Authorization: `Bearer ${data.access_token}`
                            }
                        });
                        return next.handle(req).catch((err) => {
                            return Observable.throw(err);
                        });
                    } else {
                        this.clearTaken();
                    }
                });
            } else if (err.error && err.error.message) {
                this.layoutService.showError(this.layoutService.translateText(err.error.message));
            } else {
                // HHP105 remove "Something went wrong" message to user.
                // this.authService.showError(this.layoutService.translatetext(this.translationKeys.ErrorMessages.SomethingWentWrong));
            }
            return Observable.throw(err);
        });
    }

    clearTaken() {
        window.localStorage.removeItem('access_token');
        window.localStorage.removeItem('refresh_token');
        this.router.navigateByUrl('/login');
    }
}
